<template>
  <Card variant="outline" size="medium">
    <View direction="column" gap="lg">
      <View direction="column" gap="xs">
        <Text variant="h4">Choose where your listing will be published</Text>
        <Text variant="body-medium" color="secondary">Your unit will be listed on the selected platforms</Text>
      </View>

      <View direction="column" gap="md">
        <View align="center">
          <View direction="row" gap="md" align="center" :grow="1">
            <View class="platform-icon">
              <img :src="zillowLogo" alt="Zillow" class="platform-logo" />
            </View>
            <View direction="column" gap="xs" :grow="1">
              <Text variant="label-medium" color="primary" class="platform-name">Zillow, Hotpads, Trulia</Text>
            </View>
          </View>
          <Switch v-model="syndicationData.zillow" />
        </View>

        <View align="center">
          <View direction="row" gap="md" align="center" :grow="1">
            <View class="platform-icon">
              <img :src="zumperLogo" alt="Zumper" class="platform-logo" />
            </View>
            <View direction="column" gap="xs" :grow="1">
              <Text variant="label-medium" color="primary" class="platform-name">Zumper</Text>
            </View>
          </View>
          <Switch v-model="syndicationData.zumper" />
        </View>

        <View align="center">
          <View direction="row" gap="md" align="center" :grow="1">
            <View class="platform-icon">
              <img :src="apartmentsLogo" alt="Apartments.com" class="platform-logo" />
            </View>
            <View direction="column" gap="xs" :grow="1">
              <Text variant="label-medium" color="primary" class="platform-name">Apartments.com</Text>
            </View>
          </View>
          <Switch v-model="syndicationData.apartmentsDotCom" />
        </View>

        <View align="center">
          <View direction="row" gap="md" align="center" :grow="1">
            <View class="platform-icon">
              <img :src="realtorLogo" alt="Realtor.com" class="platform-logo" />
            </View>
            <View direction="column" gap="xs" :grow="1">
              <Text variant="label-medium" color="primary" class="platform-name">Realtor.com</Text>
            </View>
          </View>
          <Switch v-model="syndicationData.realtorDotCom" />
        </View>
      </View>
    </View>
  </Card>
</template>

<script setup lang="ts">
import apartmentsLogo from 'icons/apartments-logo.png';
import realtorLogo from 'icons/realtor-logo.png';
import zillowLogo from 'icons/zillow-logo.png';
import zumperLogo from 'icons/zumper-logo.png';
import { reactive } from 'vue';

import { Card, Switch, Text, View } from '@tallo/design-system';
import { SaveSyndicationDto } from '@tallo/investor/property';

const syndicationData = reactive<SaveSyndicationDto>({
  zillow: true,
  zumper: true,
  apartmentsDotCom: true,
  realtorDotCom: true,
});

function getSyndicationData(): SaveSyndicationDto {
  return { ...syndicationData };
}

defineExpose({
  getSyndicationData,
});
</script>

<style scoped lang="scss">
.platform-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--t-border-radius-sm);
  background-color: var(--t-color-neutral-100);
  color: var(--t-color-neutral-600);
}

.platform-logo {
  width: 1.5rem;
  height: 1.5rem;
  object-fit: contain;
}

.platform-name {
  font-weight: 500;
}
</style>
